// 計測URL（/r/:slug）の slug を localStorage と Cookie の両方に保持し、
// 片方が消えても他方から復元できるようにするためのユーティリティ。
// ITP / Cookie クリアによる取りこぼし対策。

const STORAGE_KEY = "tracking_slug";
const COOKIE_NAME = "tracking_slug";
const COOKIE_TTL_DAYS = 90;
const SLUG_FORMAT = /^[a-z0-9]{1,4}$/;

function isBrowser(): boolean {
  return typeof window !== "undefined" && typeof document !== "undefined";
}

function readCookie(): string | null {
  if (!isBrowser()) return null;
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${COOKIE_NAME}=`));
  if (!match) return null;
  const value = decodeURIComponent(match.split("=")[1] ?? "");
  return SLUG_FORMAT.test(value) ? value : null;
}

function writeCookie(slug: string): void {
  if (!isBrowser()) return;
  const expires = new Date();
  expires.setDate(expires.getDate() + COOKIE_TTL_DAYS);
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(slug)}; expires=${expires.toUTCString()}; path=/; SameSite=Lax${secure}`;
}

function readLocalStorage(): string | null {
  if (!isBrowser()) return null;
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    if (!value) return null;
    return SLUG_FORMAT.test(value) ? value : null;
  } catch {
    return null;
  }
}

function writeLocalStorage(slug: string): void {
  if (!isBrowser()) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, slug);
  } catch {
    // private mode 等で書き込み不能な場合は無視
  }
}

// アプリ初期化時に呼び出す。Cookie と localStorage を同期させる。
// 両方ある場合は Cookie 優先（最新のリダイレクト経由値を尊重）。
export function syncTrackingSlug(): string | null {
  if (!isBrowser()) return null;

  const fromCookie = readCookie();
  const fromStorage = readLocalStorage();

  if (fromCookie) {
    if (fromCookie !== fromStorage) writeLocalStorage(fromCookie);
    return fromCookie;
  }

  if (fromStorage) {
    writeCookie(fromStorage);
    return fromStorage;
  }

  return null;
}

export function getTrackingSlug(): string | null {
  return readCookie() ?? readLocalStorage();
}
